import React, { useEffect, useState } from "react";
import { subscribe } from "./toast";
import styles from "./Toast.module.scss";

const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    const unsubscribe = subscribe((toast) => {
      setToasts((prev) => [...prev, toast]);

      setTimeout(() => {
        removeToast(toast.id);
      }, toast.duration);
    });

    return unsubscribe;
  }, []);

  const removeToast = (id) => {
    setToasts((prev) => prev.filter((toast) => toast.id !== id));
  };

  return (
    <>
      {children}

      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`${styles["toast_wrap"]} ${styles[`toast-${toast.type}`]}`}
        >
          <span
            className={styles["toastClose"]}
            onClick={() => removeToast(toast.id)}
          >
            x
          </span>

          <h4>
            {toast.type.charAt(0).toUpperCase() +
              toast.type.slice(1)}
          </h4>

          <p>{toast.message}</p>
        </div>
      ))}
    </>
  );
};

export default ToastProvider;